/**
 * setIfChanged — React setState wrapper that skips the update when the
 * new value is byte-identical to the previous one. Prevents polling
 * loops from re-rendering on identical payloads (the root cause of the
 * "screen keeps jumping" flicker admins reported on the Support tab and
 * elsewhere on production, Feb 2026).
 *
 * Use as:
 *   setUsers((prev) => setIfChanged(prev, nextUsers));
 *
 * Fast path: length + first/last identity → JSON-compare only when the
 * shallow shape matches. If either serialisation throws we fall through
 * and just accept the update.
 */
export function setIfChanged(prev, next) {
    if (prev === next) return prev;
    if (Array.isArray(prev) && Array.isArray(next)) {
        if (prev.length !== next.length) return next;
        if (prev.length === 0) return prev;
    }
    try {
        if (JSON.stringify(prev) === JSON.stringify(next)) return prev;
    } catch { /* fall through */ }
    return next;
}

export default setIfChanged;
